import { createFileRoute } from '@tanstack/react-router'
import AgreementSettlements from 'Royalty/components/Agreement/AgreementSettlements'

export const Route = createFileRoute('/royalty_/agreement/$id/settlements/')({
    component: AgreementSettlements,
})
